import type { BreadcrumbPartType } from '@ipen-portal/plugin-navigation-react';
import type { FC, ReactElement } from 'react';

import { notEmpty } from '@ipen-portal/plugin-common';
import { Breadcrumbs as MuiBreadcrumbs } from '@mui/material';
import { tss } from 'tss-react/mui';

import { BreadcrumbPart } from './components/BreadcrumbPart/BreadcrumbPart';

const useStyles = tss.create(({ theme }) => ({
  breadcrumbs: {
    color: theme.palette.common.white,
  },
}));

type Props = {
  groupDefinitions?: Record<
    string,
    {
      icon?: ReactElement | string;
      title: string;
    }
  >;
  parts: readonly (BreadcrumbPartType | null | undefined)[];
  titleOrder?: Record<string, number>;
};

export const Breadcrumbs: FC<Props> = ({
  groupDefinitions,
  parts,
  titleOrder,
}) => {
  const { classes } = useStyles();

  return (
    <MuiBreadcrumbs aria-label="Breadcrumbs" className={classes.breadcrumbs}>
      {parts.filter(notEmpty).map((conf, index, values) => (
        <BreadcrumbPart
          // eslint-disable-next-line @eslint-react/no-array-index-key
          key={index}
          {...conf}
          current={index === values.length - 1}
          groupDefinitions={groupDefinitions}
          titleOrder={titleOrder}
        />
      ))}
    </MuiBreadcrumbs>
  );
};
